/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'back-3': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(8 12)" _stroke="#03272E"><polyline pid="0" transform="rotate(90 2 4)" points="6 2 2 6 -2 2"/><polyline pid="1" transform="rotate(90 7 4)" points="11 2 7 6 3 2"/><polyline pid="2" transform="rotate(90 12 4)" points="16 2 12 6 8 2"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/back-3.js